import { render, staticRenderFns } from "./ChangeFailed.vue?vue&type=template&id=b77965b0&scoped=true&"
import script from "./ChangeFailed.vue?vue&type=script&lang=ts&"
export * from "./ChangeFailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77965b0",
  null
  
)

export default component.exports